export const GET_ALL_REGULAR_CERTIFICATES = "GET_ALL_REGULAR_CERTIFICATES";
export const SET_REFRESH_CERTIFICATES = "SET_REFRESH_CERTIFICATES";
